import React from "react";
import TailoringOrders from "./pages/TailoringOrders";
import TailoringOrderNew from "./pages/TailoringOrderNew";
import TailoringOrderDetail from "./pages/TailoringOrderDetail";
import ServiceOrders from "./pages/ServiceOrders";
import ServiceOrderNew from "./pages/ServiceOrderNew";
import ServiceOrderDetail from "./pages/ServiceOrderDetail";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import POS from "./pages/POS";
import Products from "./pages/Products";
import Customers from "./pages/Customers";
import Quotations from "./pages/Quotations";
import CreditNotes from "./pages/CreditNotes";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import InventoryHistory from "./pages/InventoryHistory";
import Branches from "./pages/Branches";
import InvoiceList from "./pages/InvoiceList";
import BranchInventory from "./pages/BranchInventory";
import CashRegister from "./pages/CashRegister";
import Manual from "./pages/Manual";
import Commissions from "./pages/Commissions";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pos" element={<POS />} />
              <Route path="products" element={<Products />} />
              <Route path="customers" element={<Customers />} />
              <Route path="quotations" element={<Quotations />} />
              <Route path="credit-notes" element={<CreditNotes />} />
              <Route path="invoices" element={<InvoiceList />} />
              <Route path="reports" element={<Reports />} />
              <Route path="inventory-history" element={<InventoryHistory />} />
              <Route path="branch-inventory" element={<BranchInventory />} />
              <Route path="branches" element={<Branches />} />
              <Route path="users" element={<Users />} />
              <Route path="settings" element={<Settings />} />
              <Route path="tailoring-orders" element={<TailoringOrders />} />
              <Route path="cash-register" element={<CashRegister />} />
              <Route
                path="tailoring-orders/new"
                element={<TailoringOrderNew />}
              />
              <Route
                path="tailoring-orders/:id"
                element={<TailoringOrderDetail />}
              />
              <Route path="service-orders" element={<ServiceOrders />} />
              <Route path="service-orders/new" element={<ServiceOrderNew />} />
              <Route path="service-orders/:id" element={<ServiceOrderDetail />} />
              <Route path="manual" element={<Manual />} />
              <Route path="commissions" element={<Commissions />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;